
import { defineComponent, onMounted, ref } from 'vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  setup() {
    const input = ref('');

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
      input,
    };
  },
});
